export default "__VITE_ASSET__2SPjpRmD__"